import { render, staticRenderFns } from "./ShowCompany.vue?vue&type=template&id=65f1e3f6&scoped=true&"
import script from "./ShowCompany.vue?vue&type=script&lang=js&"
export * from "./ShowCompany.vue?vue&type=script&lang=js&"
import style0 from "./ShowCompany.vue?vue&type=style&index=0&id=65f1e3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1e3f6",
  null
  
)

export default component.exports